import { z } from 'zod';

import { TSDCarrierSchema, TSDCustomsOfficeSchema, TSDPersonPresentingTheGoodsSchema } from './utils';

export const TSDViewPNGeneralInfoSchema = z.object({
  dateAndTimeOfPresentationOfTheGoods: z.any().optional(),
});

export const TSDViewPNDataSchema = z.object({
  generalInfo: TSDViewPNGeneralInfoSchema.optional(),
  customsOfficeOfPresentation: TSDCustomsOfficeSchema.optional(),
  personPresentingTheGoods: TSDPersonPresentingTheGoodsSchema.optional(),
  carrier: TSDCarrierSchema.optional(),
});
export type TSDViewPNDataFormValues = z.infer<typeof TSDViewPNDataSchema>;
